<!-- Teonet description in copyright. Set it in footer. -->
<template>
  <div>
    <div class="copyr text-center text-secondary bg-body-tertiary p-3">
      Teonet © 2025
    </div>
  </div>
</template>
